import { Platform, StyleSheet } from "react-native";

const interBold = Platform.select({
  ios: "Inter-Bold",
  android: "Inter-Bold",
  web: "Inter, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif" as any,
  default: "Inter-Bold",
});

const interRegular = Platform.select({
  ios: "Inter-Regular",
  android: "Inter-Regular",
  web: "Inter, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif" as any,
  default: "Inter-Regular",
});

const styles = StyleSheet.create({
  screenRoot: {
    flex: 1,
    backgroundColor: "#f5f9ff",
  },
  container: {
    flex: 1,
    width: "100%",
    paddingHorizontal: 36,
    paddingTop: 24,
  },
  content: { flex: 1 },
  scrollContent: { paddingBottom: 36 },

  pageHeader: {
    minHeight: 56,
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    marginBottom: 16,
    gap: 16,
  },
  pageTitleBlock: { flex: 1, minWidth: 0 },
  breadcrumbRow: { flexDirection: "row", alignItems: "center", gap: 6, marginBottom: 4 },
  breadcrumbLink: { fontSize: 12, color: "#585858", fontWeight: "500", fontFamily: interRegular },
  breadcrumbSeparator: { fontSize: 12, color: "#818181" },
  breadcrumbCurrent: { fontSize: 12, color: "#3a3a3a", fontWeight: "600", fontFamily: interBold },
  pageTitle: { fontSize: 28, fontWeight: "700", color: "#2d2d2d", lineHeight: 34, fontFamily: interBold },
  pageSubtitle: { fontSize: 13, color: "#818181", marginTop: 2, fontFamily: interRegular },

  pageActions: { flexDirection: "row", gap: 8, alignItems: "center", flexShrink: 0 },
  switcher: {
    flexDirection: "row",
    gap: 6,
    backgroundColor: "#ffffff",
    borderRadius: 100,
    padding: 3,
    borderWidth: 1,
    borderColor: "#d7e5f8",
  },
  switcherBtn: {
    flexDirection: "row",
    alignItems: "center",
    gap: 6,
    borderRadius: 100,
    paddingHorizontal: 12,
    paddingVertical: 7,
  },
  switcherBtnActive: { backgroundColor: "#034895" },
  switcherBtnPressed: { opacity: 0.82 },
  switcherBtnText: { fontSize: 12, fontWeight: "700", color: "#4b4b4b", fontFamily: interBold },
  switcherBtnTextActive: { color: "#ffffff" },

  btnGhost: {
    borderRadius: 100,
    paddingHorizontal: 18,
    paddingVertical: 9,
    backgroundColor: "transparent",
    flexDirection: "row",
    alignItems: "center",
    gap: 8,
  },
  btnGhostPressed: { backgroundColor: "#e7effb" },
  btnGhostText: { fontSize: 13, fontWeight: "700", color: "#4b4b4b", fontFamily: interBold },

  statusSummary: {
    flexDirection: "row",
    flexWrap: "wrap",
    gap: 8,
    marginBottom: 16,
    paddingVertical: 12,
    paddingHorizontal: 14,
    backgroundColor: "#ffffff",
    borderRadius: 10,
    shadowColor: "#005EC0",
    shadowOffset: { width: 0, height: 0 },
    shadowOpacity: 0.08,
    shadowRadius: 24,
    elevation: 2,
    alignItems: "center",
  },
  statusPill: {
    flexDirection: "row",
    alignItems: "center",
    gap: 6,
    backgroundColor: "#f8f8f8",
    borderWidth: 1,
    borderColor: "transparent",
    borderRadius: 100,
    paddingVertical: 6,
    paddingHorizontal: 12,
  },
  statusPillPressed: { backgroundColor: "#e7effb" },
  statusPillHovered: { backgroundColor: "#e7effb" },
  statusPillActive: { backgroundColor: "#034895", borderColor: "#034895" },
  statusDot: { width: 8, height: 8, borderRadius: 4, backgroundColor: "#7a8495" },
  statusDotActive: { borderWidth: 2, borderColor: "rgba(255,255,255,0.5)" },
  statusPillLabel: { fontSize: 12, fontWeight: "600", color: "#4b4b4b", fontFamily: interRegular },
  statusPillLabelActive: { color: "#ffffff" },
  statusPillCount: {
    minWidth: 20,
    borderRadius: 100,
    paddingHorizontal: 7,
    paddingVertical: 1,
    textAlign: "center",
    backgroundColor: "rgba(0,0,0,0.06)",
    fontSize: 11,
    fontWeight: "700",
    color: "#4b4b4b",
    fontFamily: interBold,
  },
  statusPillCountActive: { color: "#ffffff", backgroundColor: "rgba(255,255,255,0.22)" },

  dataTableWrap: {
    backgroundColor: "#ffffff",
    borderRadius: 8,
    shadowColor: "#005EC0",
    shadowOffset: { width: 0, height: 0 },
    shadowOpacity: 0.08,
    shadowRadius: 24,
    elevation: 2,
    overflow: "hidden",
  },
  tableToolbar: {
    flexDirection: "row",
    alignItems: "center",
    gap: 12,
    paddingVertical: 14,
    paddingHorizontal: 20,
    borderBottomWidth: 1,
    borderBottomColor: "#ebebeb",
    flexWrap: "wrap",
  },
  searchWrap: { flex: 1, minWidth: 200, maxWidth: 380, position: "relative" },
  searchIcon: { position: "absolute", left: 12, top: 11, zIndex: 2 },
  searchInput: {
    width: "100%",
    height: 36,
    borderWidth: 1,
    borderColor: "#d0d0d0",
    borderRadius: 6,
    paddingLeft: 36,
    paddingRight: 12,
    fontSize: 13,
    color: "#2d2d2d",
    fontFamily: interRegular,
  },
  searchClearBtn: { position: "absolute", right: 10, top: 10 },
  resultCount: { marginLeft: "auto", fontSize: 12, color: "#656565", fontWeight: "600", fontFamily: interBold },

  tableMinWidth: { minWidth: 1760, width: "100%" },
  tableHeadRow: { flexDirection: "row", borderBottomWidth: 2, borderBottomColor: "#d7e5f8", backgroundColor: "#f8fbff" },
  thCell: {
    paddingHorizontal: 12,
    paddingVertical: 11,
    color: "#4b4b4b",
    fontSize: 11,
    fontWeight: "700",
    textTransform: "uppercase",
    letterSpacing: 0.4,
    fontFamily: interBold,
    flexDirection: "row",
    alignItems: "center",
    gap: 4,
  },
  thSortable: {
    flexDirection: "row",
    alignItems: "center",
    gap: 4,
    ...(Platform.OS === "web" ? { cursor: "pointer" } as any : {}),
  },
  thText: { fontSize: 11, fontWeight: "700", color: "#4b4b4b", fontFamily: interBold },
  thTextActive: { color: "#005CBC" },
  tableBodyRow: {
    flexDirection: "row",
    borderBottomWidth: 1,
    borderBottomColor: "#ebebeb",
    backgroundColor: "#ffffff",
    alignItems: "center",
    ...Platform.select({ web: { cursor: "pointer" } as any }),
  },
  tableBodyRowHovered: { backgroundColor: "#F3F7FD" },
  tableBodyRowPressed: { backgroundColor: "#eaf2ff" },
  tdCell: { paddingHorizontal: 12, paddingVertical: 13, color: "#3a3a3a", fontSize: 13, fontFamily: interRegular },
  tdCellWrap: { paddingHorizontal: 12, paddingVertical: 13 },
  tdId: { fontSize: 12, color: "#005cbc", fontWeight: "700", fontFamily: interBold },
  tdTitle: { fontWeight: "600", color: "#2d2d2d", fontFamily: interBold },
  tdDate: { fontSize: 12, color: "#585858" },

  // Location cell
  locationPrimary: { fontSize: 13, color: "#2d2d2d", fontFamily: interRegular },
  locationSecondary: { fontSize: 11, color: "#818181", fontFamily: interRegular, marginTop: 2 },

  // Affected System tag
  systemTag: {
    backgroundColor: "#EEF4FF",
    borderRadius: 12,
    paddingHorizontal: 8,
    paddingVertical: 3,
    alignSelf: "flex-start",
    borderWidth: 1,
    borderColor: "#C7DCFF",
  },
  systemTagText: { fontSize: 12, color: "#004BAD", fontWeight: "600", fontFamily: interBold },

  // Time in Queue cell
  agingCell: { flexDirection: "column", alignItems: "flex-start", gap: 2 },
  agingRow: { flexDirection: "row", alignItems: "center", gap: 6 },
  agingPrimary: { fontSize: 13, color: "#2d2d2d", fontFamily: interRegular },
  agingPaused: { color: "#818181", textDecorationLine: "line-through" },
  agingSecondary: { fontSize: 11, color: "#8B6508", fontFamily: interRegular },
  pauseBtn: { padding: 2, borderRadius: 4 },

  // Empty state row
  emptyRow: { paddingVertical: 40, alignItems: "center", justifyContent: "center" },
  emptyRowText: { fontSize: 13, color: "#818181", fontFamily: interRegular },

  // Column widths (11 columns, total ~1760)
  colId: { width: 148 },
  colCategory: { width: 155 },
  colSubcategory: { width: 155 },
  colSubmitter: { width: 130 },
  colLocation: { width: 195 },
  colSystem: { width: 145 },
  colUrgency: { width: 125 },
  colStatus: { width: 175 },
  colAssigned: { width: 155 },
  colAging: { width: 185 },
  colSubmitted: { width: 148 },

  badge: {
    flexDirection: "row",
    alignItems: "center",
    gap: 6,
    paddingHorizontal: 10,
    paddingVertical: 4,
    borderRadius: 100,
    alignSelf: "flex-start",
  },
  badgeDot: { width: 8, height: 8, borderRadius: 4 },
  badgeText: { fontSize: 12, fontWeight: "700", fontFamily: interBold },

  urgencyCritical: { backgroundColor: "#FFE6E4" },
  urgencyCriticalDot: { backgroundColor: "#C23603" },
  urgencyCriticalText: { color: "#C23603" },
  urgencyHigh: { backgroundColor: "#FFE9D1" },
  urgencyHighDot: { backgroundColor: "#D0781D" },
  urgencyHighText: { color: "#C56F12" },
  urgencyMedium: { backgroundColor: "#FFF6CC" },
  urgencyMediumDot: { backgroundColor: "#8B6508" },
  urgencyMediumText: { color: "#8B6508" },
  urgencyLow: { backgroundColor: "#F3F4F6" },
  urgencyLowDot: { backgroundColor: "#6B7280" },
  urgencyLowText: { color: "#6B7280" },

  statusNew: { backgroundColor: "#DCE8FB" },
  statusNewDot: { backgroundColor: "#005CBC" },
  statusNewText: { color: "#005CBC" },
  statusInProgress: { backgroundColor: "#E4E0FD" },
  statusInProgressDot: { backgroundColor: "#7871E2" },
  statusInProgressText: { color: "#5C4EC9" },
  statusWaitingonIT: { backgroundColor: "#FFF6CC" },
  statusWaitingonITDot: { backgroundColor: "#FCC42B" },
  statusWaitingonITText: { color: "#8B6508" },
  statusWaitingonTMV: { backgroundColor: "#DAF4FF" },
  statusWaitingonTMVDot: { backgroundColor: "#0078A7" },
  statusWaitingonTMVText: { color: "#0078A7" },
  statusSubmittedtoADO: { backgroundColor: "#EAE4FF" },
  statusSubmittedtoADODot: { backgroundColor: "#5C4EC9" },
  statusSubmittedtoADOText: { color: "#5C4EC9" },
  statusWaitingonUser: { backgroundColor: "#FFE9D1" },
  statusWaitingonUserDot: { backgroundColor: "#FF8C09" },
  statusWaitingonUserText: { color: "#D0781D" },
  statusClosed: { backgroundColor: "#E9F6EA" },
  statusClosedDot: { backgroundColor: "#027C06" },
  statusClosedText: { color: "#027C06" },

  pagination: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    paddingHorizontal: 20,
    paddingVertical: 12,
    borderTopWidth: 1,
    borderTopColor: "#ebebeb",
  },
  paginationText: {
    fontSize: 12,
    color: "#656565",
    fontFamily: interRegular,
    flexShrink: 1,
    paddingRight: 12,
  },

  kanbanRoot: {
    position: "relative",
  },
  kanbanWrap: {
    gap: 12,
    paddingBottom: 4,
  },
  kanbanCol: {
    width: 290,
    backgroundColor: "#f8fbff",
    borderRadius: 10,
    borderWidth: 1,
    borderColor: "#dfe9f7",
    padding: 10,
  },
  kanbanColDragOver: {
    borderColor: "#005cbc",
    borderStyle: "dashed",
    backgroundColor: "#eef5ff",
  },
  kanbanColHeader: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    marginBottom: 8,
  },
  kanbanColTitleWrap: { flexDirection: "row", alignItems: "center", gap: 6 },
  kanbanColTitle: { fontSize: 13, color: "#2d2d2d", fontWeight: "700", fontFamily: interBold },
  kanbanColCount: { fontSize: 12, color: "#4b4b4b", fontWeight: "700", fontFamily: interBold },
  kanbanColBody: { gap: 8 },
  kanbanColBodyEmptyDrop: { minHeight: 76 },
  dropPlaceholder: {
    minHeight: 60,
    borderRadius: 8,
    borderWidth: 2,
    borderStyle: "dashed",
    borderColor: "#005cbc",
    backgroundColor: "rgba(0, 92, 188, 0.08)",
    alignItems: "center",
    justifyContent: "center",
    marginBottom: 8,
  },
  dropPlaceholderText: {
    color: "#005cbc",
    fontSize: 11,
    fontWeight: "700",
    letterSpacing: 0.4,
    textTransform: "uppercase",
    fontFamily: interBold,
  },
  kanbanCard: {
    backgroundColor: "#ffffff",
    borderRadius: 8,
    borderWidth: 1,
    borderColor: "#e6edf8",
    padding: 10,
    position: "relative",
    ...Platform.select({ web: { cursor: "grab" } as any }),
  },
  kanbanCardDragging: {
    opacity: 0.45,
    ...Platform.select({ web: { cursor: "grabbing" } as any }),
  },
  kanbanCardPressed: { opacity: 0.85 },
  kcEditBtn: {
    width: 24,
    height: 24,
    borderRadius: 12,
    borderWidth: 1,
    borderColor: "#d0d0d0",
    backgroundColor: "#ffffff",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 2,
    opacity: 0,
  },
  kcEditBtnVisible: {
    opacity: 1,
  },
  kcEditBtnHovered: {
    backgroundColor: "#005cbc",
    borderColor: "#005cbc",
    opacity: 1,
  },
  kcEditBtnPressed: {
    opacity: 0.88,
  },
  kanbanCardTop: { flexDirection: "row", justifyContent: "space-between", alignItems: "center", marginBottom: 8 },
  kanbanCardId: { fontSize: 12, color: "#005cbc", fontWeight: "700", fontFamily: interBold },
  kanbanCardTitle: { fontSize: 13, color: "#2d2d2d", fontWeight: "600", fontFamily: interBold, marginBottom: 6 },
  kanbanCardMeta: { flexDirection: "row", justifyContent: "space-between", gap: 8, marginBottom: 8 },
  kanbanCardMetaText: { fontSize: 11, color: "#656565", fontFamily: interRegular },
  kanbanCardFooter: { flexDirection: "row", justifyContent: "space-between", alignItems: "center" },
  kanbanAssignee: { fontSize: 11, color: "#2d2d2d", fontWeight: "600", fontFamily: interRegular },
  kanbanAssigneeUnassigned: { fontSize: 11, color: "#C23603", fontWeight: "700", fontFamily: interBold },
  kanbanAging: { fontSize: 11, color: "#656565", fontFamily: interRegular },

  quickEditCard: {
    marginTop: 10,
    borderRadius: 8,
    borderWidth: 1,
    borderColor: "#d7e5f8",
    backgroundColor: "#f7fbff",
    padding: 10,
    gap: 8,
  },
  quickEditTitle: {
    fontSize: 12,
    fontWeight: "700",
    color: "#034895",
    fontFamily: interBold,
  },
  quickEditField: {
    gap: 4,
  },
  quickEditFieldRow: {
    flexDirection: "row",
    gap: 8,
  },
  quickEditFieldHalf: {
    flex: 1,
    minWidth: 0,
    gap: 4,
  },
  quickEditLabel: {
    fontSize: 11,
    fontWeight: "700",
    color: "#585858",
    textTransform: "uppercase",
    letterSpacing: 0.4,
    fontFamily: interBold,
  },
  quickEditTitleInput: {
    width: "100%",
    minHeight: 54,
    fontSize: 13,
    color: "#2d2d2d",
    lineHeight: 18,
    paddingHorizontal: 10,
    paddingVertical: 8,
    borderRadius: 6,
    borderWidth: 1,
    borderColor: "#d0d0d0",
    backgroundColor: "#ffffff",
    textAlignVertical: "top",
    fontFamily: interRegular,
  },
  quickEditSelect: {
    minHeight: 34,
    borderRadius: 6,
    borderWidth: 1,
    borderColor: "#d0d0d0",
    backgroundColor: "#ffffff",
    paddingHorizontal: 10,
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    gap: 8,
  },
  quickEditSelectText: {
    fontSize: 12,
    color: "#2d2d2d",
    fontFamily: interRegular,
    flexShrink: 1,
  },
  quickEditOptions: {
    borderRadius: 6,
    borderWidth: 1,
    borderColor: "#d7e5f8",
    backgroundColor: "#ffffff",
    overflow: "hidden",
  },
  quickEditOption: {
    paddingHorizontal: 10,
    paddingVertical: 8,
    borderBottomWidth: 1,
    borderBottomColor: "#eef3fa",
  },
  quickEditOptionText: {
    fontSize: 12,
    color: "#2d2d2d",
    fontFamily: interRegular,
  },
  quickEditCancelBtn: {
    borderRadius: 100,
    borderWidth: 1,
    borderColor: "#d0d0d0",
    paddingHorizontal: 10,
    paddingVertical: 5,
    backgroundColor: "#ffffff",
  },
  quickEditCancelText: {
    fontSize: 11,
    color: "#4b4b4b",
    fontWeight: "700",
    fontFamily: interBold,
  },
  quickEditSaveBtn: {
    borderRadius: 100,
    paddingHorizontal: 10,
    paddingVertical: 5,
    backgroundColor: "#005cbc",
  },
  quickEditSaveText: {
    fontSize: 11,
    color: "#ffffff",
    fontWeight: "700",
    fontFamily: interBold,
  },

  quickEditBackdrop: {
    ...Platform.select({
      web: {
        position: "fixed",
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
      } as any,
      default: {
        position: "absolute",
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
      },
    }),
    backgroundColor: "transparent",
    zIndex: 80,
  },
  quickEditPopover: {
    width: 340,
    borderRadius: 12,
    backgroundColor: "#ffffff",
    borderWidth: 1,
    borderColor: "#e6edf8",
    shadowColor: "#3a3a3a",
    shadowOffset: { width: 0, height: 4 },
    shadowOpacity: 0.14,
    shadowRadius: 22,
    elevation: 8,
    zIndex: 90,
    overflow: "hidden",
    ...Platform.select({
      web: {
        position: "fixed",
      } as any,
      default: {
        position: "absolute",
      },
    }),
  },
  quickEditPopoverInline: {
    top: 24,
    left: 12,
  },
  quickEditPopoverHeader: {
    minHeight: 48,
    borderBottomWidth: 1,
    borderBottomColor: "#ebebeb",
    paddingHorizontal: 16,
    paddingVertical: 12,
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    backgroundColor: "#ffffff",
  },
  quickEditPopoverTitleWrap: {
    flexDirection: "row",
    alignItems: "center",
    gap: 6,
    flexShrink: 1,
  },
  quickEditPopoverTitle: {
    fontSize: 13,
    color: "#2d2d2d",
    fontWeight: "700",
    fontFamily: interBold,
  },
  quickEditPopoverId: {
    fontSize: 11,
    color: "#005cbc",
    fontWeight: "700",
    backgroundColor: "#E8F0FB",
    borderRadius: 100,
    paddingHorizontal: 8,
    paddingVertical: 2,
    fontFamily: interBold,
  },
  quickEditCloseBtn: {
    width: 26,
    height: 26,
    borderRadius: 13,
    borderWidth: 1,
    borderColor: "#d0d0d0",
    backgroundColor: "#ffffff",
    alignItems: "center",
    justifyContent: "center",
  },
  quickEditPopoverBody: {
    paddingHorizontal: 16,
    paddingTop: 14,
    paddingBottom: 14,
    gap: 12,
  },
  quickEditFooter: {
    flexDirection: "row",
    justifyContent: "flex-end",
    gap: 6,
    paddingHorizontal: 16,
    paddingVertical: 10,
    backgroundColor: "#f8f8f8",
    borderTopWidth: 0,
    marginTop: 0,
  },
});

export default styles;
